import React from 'react'
import { useRef, useState } from 'react'
import { SLowcodeList, SIDRender, SBack, SDrawer } from 'shj-components'
import config from './config'
import { transferFindResponseListByPage } from '@/services/fmsServices'
import { TransFerForm } from './components/addOrEdit'
import { useParams } from 'react-router-dom'
export default function PaymentServiceManage() {
  const [openModal, setModal] = useState(false)
  const [editData, setEditData] = useState<any>(null)
  const listRef = useRef<any>()
  const { id } = useParams()
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        query.orderId = id
        transferFindResponseListByPage(current, pageSize, query).then(res => {
          resolve(res)
        })
      } catch (e) {
        reject({ success: false })
      }
    })
  }

  const onDetail = (record: any) => {
    setEditData({ ...record })
    setModal(true)
  }
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      resolve({})
    })
  }
  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: {},
    customRender: {
      IdRender(text: any, record: any) {
        return (
          <SIDRender id={text} onClick={() => onDetail(record)} copy={false}></SIDRender>
        )
      },
      renderOperate(_, record: Record<string, any>) { },
    },
  }
  return (
    <SBack title={`转款查询`} level={2}>
      <div style={{ backgroundColor: '#fff', padding: '15px', minWidth: '800px' }}>
        <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
        {/* 转款 */}
        <SDrawer
          title={editData ? '转款单查询' : '转款单查询'}
          width="50%"
          isHideResetBtn={false}
          open={openModal}
          onClose={() => setModal(false)}
          footer={null}
          destroyOnClose
        >
          <TransFerForm editData={editData} />
        </SDrawer>
      </div>
    </SBack>
  )
}
